import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

function Switcher() {
  const dayNightRef = useRef(null);
  const [isDarkMode, setIsDarkMode] = useState(true); // Default to dark mode

  useEffect(() => {
    // Apply dark mode by default when the component mounts
    if (isDarkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }

    // Listen for theme toggle clicks
    const toggleTheme = () => {
      // Toggle the dark mode class on the body
      document.body.classList.toggle("dark");
      
      // Toggle the state to reflect the current mode
      setIsDarkMode(prevMode => !prevMode);
    };

    const dayNight = dayNightRef.current;
    dayNight.addEventListener("click", toggleTheme);

    // Cleanup event listener on unmount
    return () => {
      dayNight.removeEventListener("click", toggleTheme);
    };
  }, [isDarkMode]); // Depend on isDarkMode to re-run effect when it changes

  return (
    <div className="style-switcher">
      <div className="style-switcher-toggler day-night s-icon" ref={dayNightRef}>
        <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} />
      </div>
    </div>
  );
}

export default Switcher;